import { RootState } from "@/modules/common";

export const selectIsAuthenticated = ({ auth }: RootState) =>
  !auth.isLoading && Boolean(auth.user);
